import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ClientPortalAreaProps {
  linkButton: ReactNode
}

export const ClientPortalArea = ({ linkButton }: ClientPortalAreaProps) => {
  return (
    <>
      <div className={cn('px-6')}>
        <h3 className={cn('mb-[18px]', 'text-base font-medium')}>Client Portal</h3>
        <ul className={cn('mb-4', 'list-disc', 'pl-5', 'text-sm leading-6')}>
          <li>A dedicated client portal for this case.</li>
          <li>Open access for anyone to view the case status history.</li>
          <li>Display of the organization information.</li>
        </ul>
      </div>

      <div className={cn('flex', 'mb-3', 'w-full', 'px-6')}>{linkButton}</div>
      <div className={cn('mb-6', 'px-7', 'text-xs leading-5 text-muted-foreground')}>
        Keep your applicant informed by sharing the link to the client portal.
      </div>
    </>
  )
}
